import { StudentNote, StudentNoteNameFragment, StudentNoteNoteType } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: StudentNoteNameFragment) {
	return instance.id;
}

export function noteTypeIndefiniteArticle(instance: Pick<StudentNote, "noteType">) {
	switch (instance.noteType) {
		case StudentNoteNoteType.Behavior:
		case StudentNoteNoteType.General:
		case StudentNoteNoteType.Health:
		case StudentNoteNoteType.Medication:
		case StudentNoteNoteType.SocialEmotional:
			return "a";
		case StudentNoteNoteType.Academic:
		case StudentNoteNoteType.Attendance:
		case StudentNoteNoteType.Incident:
		case StudentNoteNoteType.Injury:
			return "an";
	}
}

export function authorLabel(instance: Pick<StudentNote, "noteType">) {
	switch (instance.noteType) {
		case StudentNoteNoteType.Academic:
		case StudentNoteNoteType.Attendance:
		case StudentNoteNoteType.General:
		case StudentNoteNoteType.Health:
		case StudentNoteNoteType.Medication:
			return "Author";
		case StudentNoteNoteType.Behavior:
		case StudentNoteNoteType.Incident:
		case StudentNoteNoteType.Injury:
		case StudentNoteNoteType.SocialEmotional:
			return "Reporter";
	}
}

export const bodyLabels = {
	academic: "Issue Description",
	attendance: "Description",
	behavior: "Incident Description",
	general: "Note",
	health: "Note",
	incident: "Incident Description",
	injury: "Incident and Injury Description",
	medication: "Note",
	socialEmotional: "Issue Description",
};

export function bodyLabel(instance: Pick<StudentNote, "noteType">) {
	switch (instance.noteType) {
		case StudentNoteNoteType.Academic:
			return "Issue Description";
		case StudentNoteNoteType.Attendance:
			return "Description";
		case StudentNoteNoteType.Behavior:
			return "Incident Description";
		case StudentNoteNoteType.General:
			return "Note";
		case StudentNoteNoteType.Health:
			return "Note";
		case StudentNoteNoteType.Incident:
			return "Incident Description";
		case StudentNoteNoteType.Injury:
			return "Incident Description";
		case StudentNoteNoteType.Medication:
			return "Note";
		case StudentNoteNoteType.SocialEmotional:
			return "Issue Description";
	}
}
